import React from 'react';
import PropTypes from 'prop-types';
import { withTheme, ThemeProvider } from 'styled-components';
import { PageNav, PageNavItem } from 'components/PageStyles';
import Sidebar from 'components/Sidebar';
import themes from 'containers/App/themes';

import { FormattedMessage } from 'react-intl';
import messages from './messages';

function KnowledgeSidebar({ theme: { themeId } }) {
  return (
    <ThemeProvider theme={themeId === 'extra-light' ? { ...themes.light, themeId } : themes.dark}>
      <Sidebar>
        <PageNav>
          <PageNavItem active><FormattedMessage {...messages.content} /></PageNavItem>
        </PageNav>
      </Sidebar>
    </ThemeProvider>
  );
}

KnowledgeSidebar.propTypes = {
  theme: PropTypes.object,
};

export default withTheme(KnowledgeSidebar);
